import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { SectionLabel } from './styleConstants';
import styles from './EngineeringSection.module.css';

const RING_ENGINEERING_IMAGE = '/RingPro/ring-engineering.webp';
const BG_VECTORS_IMAGE = '/RingPro/engineering-bg-vectors.svg';

const FEATURE_KEYS = ['connectivity', 'processing', 'charging', 'proRelease'];

const EngineeringSection = () => {
  const t = useTranslations('ring-pro');

  return (
    <section className={styles.section}>
      <Image
        className={styles.bgVectors}
        src={BG_VECTORS_IMAGE}
        alt=""
        width={974}
        height={1385}
        aria-hidden="true"
      />
      <div className={styles.header}>
        <SectionLabel>{t('ring-pro.engineering.label')}</SectionLabel>
        <h2 className={styles.heading}>{t('ring-pro.engineering.heading')}</h2>
      </div>
      <div className={styles.contentWrapper}>
        <div className={styles.leftColumn}>
          <Image
            className={styles.ringImage}
            src={RING_ENGINEERING_IMAGE}
            alt={t('ring-pro.engineering.imageAlt')}
            width={550}
            height={1600}
          />
        </div>
        <div className={styles.rightColumn}>
          {FEATURE_KEYS.map((key) => (
            <div className={styles.featureItem} key={key}>
              <p className={styles.featureTitle}>{t(`ring-pro.engineering.${key}.title`)}</p>
              <p className={styles.featureDescription}>{t(`ring-pro.engineering.${key}.description`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EngineeringSection;
